/* eslint-disable */
export default {
  unmute: 'Ativar som',
  mute: 'Desativar som',
  keypad: 'Teclado',
  hold: 'Em espera',
  onHold: 'Em espera',
  park: 'Parquear',
  stopRecord: 'Parar',
  record: 'Gravar',
  add: 'Adicionar',
  transfer: 'Transferir',
  flip: 'Transferência',
  more: 'Ações chamada',
  mergeToConference: 'Unir',
  end: 'Terminar',
  completeTransfer: 'Concluir\ntransferência',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
